import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAnalyticsData } from '../store/events';
import { useAnalyticsData } from './useAnalyticsData';

export const useSyncAnalyticsToStorage = () => {
  const dispatch = useDispatch();
  const analyticsData = useAnalyticsData();

  useEffect(() => {
    dispatch(setAnalyticsData(analyticsData));
  }, [dispatch, analyticsData]);
};
